import AddToCartButtonEvents from '@/modules/tracking/events/helper/addToCartButton'
import { Event } from '@/modules/tracking/types'
import { BaseModelResource, ProductClass } from '@/types/index'

export default class CtoEvent extends Event {
  static readonly Choose = class {
    static readonly Class = (productClass: ProductClass): CtoEvent => {
      return new CtoEvent('Produktklasse ausgewählt', productClass.productClassDescription)
    }
    static readonly BaseModel = (baseModel: BaseModelResource): CtoEvent => {
      return new CtoEvent('Basismodell ausgewählt', baseModel.baseModel.description)
    }
  }
  static readonly AddToCart: AddToCartButtonEvents = {
    addToCart: new CtoEvent('Zum Warenkorb hinzugefügt'),
    quoteRequest: new CtoEvent('Produkt per Angebotsfunktion angefragt'),
    emailRequest: new CtoEvent('Produkt per E-Mail angefragt')
  }

  protected constructor(action: string, label?: string) {
    super('Apple CTO', action, label ?? '')
  }
}
